/* assets/ba-preview-keeper.js
   WHAT: While previewing an unpublished theme, keeps the preview context on every
         internal link you click.

   WHY:  Owner 2026-08-25: "the pumpx link goes nowhere", and earlier the same day
         "the support page has no cateogires or anytihng. what have you donr to it?"
         Both had one cause: clicking an internal link inside the draft preview
         silently drops you onto the LIVE Venture theme, where our sections do not
         exist. The page still returns 200, so it looks like the work vanished
         rather than like a lost preview session.

         This shop is known to strip the preview cookie on the primary-domain hop -
         it is exactly why our preview URLs carry `_fd=0&_sc=1`. Rather than expect
         anyone to hand-append that to every link they click, this re-attaches the
         preview parameters to same-origin links as the page loads.

   INERT IN PRODUCTION: it does nothing at all unless `preview_theme_id` is present
         in the current URL, which only happens while previewing an unpublished
         theme. After cutover the draft becomes live and this never runs again.

   WHEN: 2026-08-25.
*/
(function () {
  'use strict';

  var here = new URL(window.location.href);
  var themeId = here.searchParams.get('preview_theme_id');
  if (!themeId) return;                       // not previewing - do nothing

  // The two companions matter as much as the id: without them the storefront
  // password redirect and the domain hop drop the preview cookie again.
  var CARRY = { preview_theme_id: themeId, _fd: '0', _sc: '1' };

  function decorate(a) {
    var href = a.getAttribute('href');
    if (!href) return;

    // Leave alone: anchors, non-http schemes (mailto/tel/javascript), downloads,
    // and anything pointing off-site.
    if (href.charAt(0) === '#') return;
    if (/^(mailto:|tel:|javascript:|sms:)/i.test(href)) return;
    if (a.hasAttribute('download')) return;

    var url;
    try { url = new URL(href, window.location.origin); }
    catch (e) { return; }
    if (url.origin !== window.location.origin) return;

    // Files on the CDN (manuals, images) must not be rewritten - they are not
    // theme-rendered pages and the params would just be noise on a PDF.
    if (url.pathname.indexOf('/cdn/') === 0) return;

    var touched = false;
    for (var k in CARRY) {
      if (!url.searchParams.has(k)) { url.searchParams.set(k, CARRY[k]); touched = true; }
    }
    if (touched) a.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function run() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) decorate(links[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Menus, drawers and filtered grids insert links after load, so catch those too.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'A') decorate(n);
          if (n.querySelectorAll) {
            var inner = n.querySelectorAll('a[href]');
            for (var k = 0; k < inner.length; k++) decorate(inner[k]);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
